import { memo } from 'react'

import PoweredBy from 'src/components/shared/footer/PoweredBy'

const PoweredByWrapper = () => <PoweredBy />

export default memo(PoweredByWrapper)
